'use client'
import React,{useState} from 'react';
import EmployAside from '../../aside';
import MesDemarches from './mes-demarches';

const MesDemarchesPage = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    

    <div className='main-page-wrapper'>
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <MesDemarches setIsOpenSidebar={setIsOpenSidebar}/>
    </div>    
  );
};

export default MesDemarchesPage;